import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { TableStore } from '../components/table2/table_store'
import { TargetsTable } from '../components/targets/TargetsTable'
import { useSavedFiltersStore } from '../hooks/useSavedFiltersStore'
import { useUser } from '../hooks/useUser'
import { useTableHooksFromStore } from '../packages/blueprint-components/src/useTableHooks'
import { userStore } from '../stores/user_store'
import type { TargetPerformance } from '../types/target'
import { adManagerPerformanceGet } from '../util/adManagerPerformanceApi'

export const Targets = observer(() => {
    const { profile } = useUser()
    const [store] = useState(new TableStore<TargetPerformance>(userStore, 'targets'))
    const savedFiltersStore = useSavedFiltersStore()

    const load = (params: any) => {
        if (!profile) {
            return Promise.resolve()
        }

        return adManagerPerformanceGet('api/v5/targets', params, true)
    }

    const tableHooks = useTableHooksFromStore(load, {}, false, store)

    return (
        <TargetsTable tableHooks={tableHooks} store={store} savedFiltersStore={savedFiltersStore} />
    )
})
